import {Component, Input, OnInit} from '@angular/core';
import {Block} from '../../shared/models/models';
import {ServerService} from '../../shared/services/server.service';
import {ModalWindowComponent} from '../../std-components/modal-window/modal-window.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-editblock',
  templateUrl: './editblock.component.html',
  styleUrls: ['./editblock.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class EditblockComponent implements OnInit {
  @Input() spotID;
  @Input() block: Block;

  constructor(private serverService: ServerService,
    private modalWindow: ModalWindowComponent) { }

  ngOnInit() {
  }

  addBlock() {
    this.serverService.insertBlock(this.block).then(() => {
      this.modalWindow.closeModalWindow();
    });
  }
  cancel() {
    this.modalWindow.closeModalWindow();
  }

}
